//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BodiesToExport",0,"SelectDisplayableObjectList",0],[0,"CsysOfexportPosition",1,"CoordinateSystem",0],[0,"DataCompression",1,0],[0,"ExportAppearanceSchemes",1,0],[0,"ExportAssemblyArrangements",1,0],[0,"ExportAssemblyExplosions",1,0],[0,"ExportCameras",1,0],[0,"ExportEntity",1,0],[0,"ExportMotionAnimation",1,0],[0,"ExportPositionType",1,0],[0,"FileLocation",1,0],[0,"Format",1,0]],[[["selectedAnimations"],"SetSelectedAnimations",{},1,0]],[]];
SPLM.ExtendedRealityFileCreator = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ExtendedRealityFileCreator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ExtendedRealityFileCreator.ObjectToExport = Object.freeze({
    "EntirePart" : "EntirePart", "SelectedObjects" : "SelectedObjects"});

SPLM.ExtendedRealityFileCreator.ExportedPositionCSYS = Object.freeze({
    "Absolute" : "Absolute", "Wcs" : "Wcs", "UserDefined" : "UserDefined"});

SPLM.ExtendedRealityFileCreator.OutputFormat = Object.freeze({
    "Gltf" : "Gltf", "Glb" : "Glb", "Usdz" : "Usdz"});

export default SPLM;